import { Button, Container, styled, Typography, useTheme } from "@mui/material";
import { Modal } from "../modal/index.js";
import { QrReader as QrReaderRaw } from "react-qr-reader";
import { SupportContext } from "./provider.js";
import { useTranslation } from "next-i18next";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import React from "react";
const ViewFinder = () => {
    const theme = useTheme();
    return (React.createElement(React.Fragment, null,
        React.createElement("svg", { width: "50px", viewBox: "0 0 100 100", style: {
                border: "50px solid rgba(0, 0, 0, 0.25)",
                boxSizing: "border-box",
                height: "100%",
                left: 0,
                position: "absolute",
                top: 0,
                width: "100%",
                zIndex: 1,
            } },
            React.createElement("path", { fill: "none", d: "M13,0 L0,0 L0,13", stroke: theme.palette.primary.main, strokeWidth: "5" }),
            React.createElement("path", { fill: "none", d: "M0,87 L0,100 L13,100", stroke: theme.palette.primary.main, strokeWidth: "5" }),
            React.createElement("path", { fill: "none", d: "M87,100 L100,100 L100,87", stroke: theme.palette.primary.main, strokeWidth: "5" }),
            React.createElement("path", { fill: "none", d: "M100,13 L100,0 87,0", stroke: theme.palette.primary.main, strokeWidth: "5" }))));
};
const QrReader = styled(QrReaderRaw) `
  &&& {
    section {
      div {
        box-shadow: #000 0px 0px 0px 3px inset !important;
      }
    }
  }
`;
export const QrCodeReaderModal = NiceModal.create(() => {
    const modal = useModal();
    const { t } = useTranslation("c-support");
    const { submitAccessCode } = React.useContext(SupportContext);
    const handleScanResult = (result) => {
        if (result && result.getText()) {
            const data = result.getText();
            const parsedAccessCode = data.match(/[A-Z2-9]{20}$/);
            if (parsedAccessCode && Array.isArray(parsedAccessCode) && parsedAccessCode.length > 0) {
                const accessCode = parsedAccessCode[0].trim();
                submitAccessCode(accessCode, "qr-code");
            }
        }
    };
    return (React.createElement(Modal, { label: t("qr-code-btn-label", "QR Code scannen"), open: modal.visible, onClose: modal.hide, snapPoints: [0.75] },
        React.createElement(Container, { maxWidth: "xl" },
            React.createElement(Typography, { variant: "h5" }, t("qr-scanner-title", "Zugangscode scannen")),
            React.createElement(Typography, { variant: "body1", sx: { mb: 2 } }, t("qr-scanner-copy", "Bitte scanne den QR Code, der auf dem Blatt mit dem Titel „Zugangscode“ in deinem Krimidinner abgedruckt ist.")),
            React.createElement(QrReader, { constraints: { aspectRatio: 1, facingMode: "environment" }, onResult: handleScanResult, scanDelay: 500, ViewFinder: ViewFinder }),
            React.createElement(Button, { fullWidth: true, variant: "outlined", size: "small", onClick: modal.hide, sx: { mt: 3 } }, t("close", "Schließen")))));
});
//# sourceMappingURL=qr-code-reader.js.map